"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _react = _interopRequireDefault(require("react"));
var _leaderboardIllus = _interopRequireDefault(require("../../../assets/images/bttf/leaderboard-illus.png"));
var _levelsIllus = _interopRequireDefault(require("../../../assets/images/bttf/levels-illus.png"));
var _tffp = _interopRequireDefault(require("../../../assets/images/bttf/tffp.png"));
var _geovelo = _interopRequireDefault(require("../../../assets/images/geovelo.svg"));
var _missionIllus = _interopRequireDefault(require("../../../assets/images/mission-illus.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const sponsors = [{
  key: 'geovelo',
  icon: _geovelo.default,
  title: 'Geovelo',
  description: 'Expert des itinéraires vélo sécurisés et de la mobilité durable'
}, {
  key: 'tffp',
  icon: _tffp.default,
  title: 'Team for the Planet',
  description: 'Collectif citoyen engagé contre le dérèglement climatique'
}];
function InfoCard() {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 5,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.25rem",
    fontWeight: 700
  }, "Un challenge \xE0 points engag\xE9 organis\xE9 par Team for the Planet et Geovelo"), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, "Transformons symboliquement nos rues, nos quartiers et notre quotidien, simplement en p\xE9dalant collectivement\xA0!")), /*#__PURE__*/_react.default.createElement(Card, {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Les \xE9missions de CO2 \xE9vit\xE9es gr\xE2ce aux trajets v\xE9lo de tous les participants permettent de transformer petit \xE0 petit notre ville en une ville moins carbon\xE9e et plus souhaitable\xA0!"),
    illustration: _levelsIllus.default,
    title: "Roulez pour b\xE2tir ensemble une cit\xE9 id\xE9ale"
  }), /*#__PURE__*/_react.default.createElement(Card, {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Gagnez des points en faisant des kilom\xE8tres \xE0 v\xE9lo avec l'application Geovelo. Bonus pour votre premier trajet v\xE9lo, vos trajets domicile-travail, et si vous invitez des coll\xE8gues\xA0!"),
    illustration: _leaderboardIllus.default,
    title: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Cumulez des points d'impact et surpassez les autres entreprises\xA0!")
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 2
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.25rem",
    fontWeight: 700
  }, "Une alliance engag\xE9e"), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, "Plus qu'un simple challenge v\xE9lo, Bike to the Future est organis\xE9 par deux acteurs engag\xE9s\xA0:")), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "stretch",
    display: "flex",
    flexWrap: "wrap",
    gap: 3
  }, sponsors.map(({
    key,
    icon,
    title,
    description
  }) => /*#__PURE__*/_react.default.createElement(_Box2.default, {
    key: key,
    width: {
      '@': '100%',
      '@500': 'calc((100% - 24px) / 2)',
      '@800': '100%',
      '@900': 'calc((100% - 24px) / 2)'
    }
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    border: "1px solid #dde0e7",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    height: "100%",
    padding: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#f3f6ff",
    borderRadius: 8,
    display: "flex",
    height: 64,
    justifyContent: "center",
    width: 64
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: icon,
    width: 32
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, title), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, description))))))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    bgcolor: "#ecfbf4",
    borderRadius: 3,
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    gap: 3,
    padding: 3
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _missionIllus.default,
    style: {
      flexShrink: 0
    },
    width: 100
  }), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, "Notre mission commune : r\xE9duire l'empreinte carbone des trajets quotidien en favorisant la mobilit\xE9 douce. Chaque kilom\xE8tre p\xE9dal\xE9, c'est un pas de plus vers une ville plus vivable, plus verte, plus humaine\xA0!")));
}
function Card({
  illustration,
  title,
  description
}) {
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row',
      '@800': 'column',
      '@900': 'row'
    },
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    flexShrink: 0,
    width: {
      '@': '100%',
      '@500': 224,
      '@800': '100%',
      '@900': 224
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: illustration,
    width: "100%"
  })), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontWeight: 700
  }, title), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "body2"
  }, description)));
}
var _default = exports.default = InfoCard;